import React from 'react';

import formatDate from 'helpers/formatDate';

import CountryFlag from 'components/base/CountryFlag/index';
import Box from 'components/elements/Box';
import P from 'components/elements/p';
import { ConcertCell as Cell, ConcertRow as Row } from './styles';

import { ICountryFlagProps } from 'types/shared';

interface ITableRowProps {
  cityName: string;
  countryMetadata?: ICountryFlagProps;
  countryName: string;
  date: Date | null;
  tourName: string;
  venue: string;
}

const TableRow: React.FC<ITableRowProps> = ({
  cityName,
  countryMetadata,
  countryName,
  date,
  tourName,
  venue,
}) => {
  return (
    <Row>
      <Cell className="date">
        {formatDate(date, 'day-short', false, false)}
      </Cell>
      <Cell>
        <Box display="flex" alignItems="baseline">
          {countryMetadata && <CountryFlag small {...countryMetadata} />}
          <P m={0}>{countryName}</P>
        </Box>
      </Cell>
      <Cell>{cityName}</Cell>
      <Cell>{tourName}</Cell>
      <Cell>{venue}</Cell>
    </Row>
  );
};

export default TableRow;
